import React from 'react'
import styled from 'styled-components'
import { useWeb3React } from '@web3-react/core'

export interface EarnedProps {
  earnings: number
  sousId: number
}

const Amount = styled.span`
  color: #ffffff97;
  font-size: 18px;
  display: flex;
  align-items: center;
`

const Earned: React.FC<EarnedProps> = ({ earnings }) => {
  const { account } = useWeb3React()
  const displayBalance = account ? earnings.toLocaleString(undefined, { maximumFractionDigits: 4 }) : '?'

  return <Amount>{displayBalance}</Amount>
}

export default Earned
